/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { Plan, upgradeReasons } from '@zapier/upsells/src/types';

import { CancelButton } from '../CancelButton';
import { ExtendTrialButton } from '../ExtendTrialButton';
import { NudgeImage } from '../NudgeImage';
import { UpgradeButton } from '../UpgradeButton';

import { getActiveView } from './getActiveView';

export type Props = {
  canExtendTrial: boolean;
  destinationPlan: Plan;
  onClose: () => void;
  onExtendTrialClick: () => void;
  onUpgradeClick: () => void;
};

export const ZapLimitUpgradeNudge = ({
  canExtendTrial,
  destinationPlan,
  onClose,
  onExtendTrialClick,
  onUpgradeClick,
}: Props) => {
  const activeView = getActiveView({
    canExtendTrial,
    destinationPlan,
    onUpgradeClick,
  });

  const secondaryButton = canExtendTrial ? (
    <ExtendTrialButton
      key="extend-trial"
      onClick={onExtendTrialClick}
      text="Try Professional"
    />
  ) : (
    <CancelButton key="cancel" onClick={onClose} />
  );

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={[
        secondaryButton,
        <UpgradeButton
          key="upgrade"
          onClick={onUpgradeClick}
          text={activeView.upgradeButtonText}
        />,
      ]}
      headingText="You've run out of Zaps"
      id="live-zaps"
      image={<NudgeImage type={upgradeReasons.zapLimit} />}
      subtitleText="Heads Up"
    />
  );
};
